import { LuUser, LuPlug } from 'react-icons/lu';

const navItems = [
  { key: 'account', label: 'Account', path: '/account', icon: LuUser },
  { key: 'integrations', label: 'Integrations', path: '/account/integrations', icon: LuPlug },
];

const AccountNav = ({ activeKey, onSelect, onBack }) => (
  <aside className="sticky top-0 flex w-full md:w-64 flex-row md:flex-col items-center md:items-stretch md:h-screen border-b md:border-b-0 md:border-r border-white/5 bg-[#0c1428]/90 px-3 md:px-4 py-3 md:py-6 backdrop-blur gap-2">
    <div className="flex flex-row md:flex-col gap-1 w-full">
      {navItems.map((item) => {
        const Icon = item.icon;
        return (
          <button
            key={item.key}
            type="button"
            onClick={() => onSelect(item.key)}
            className={`flex items-center justify-center md:justify-start gap-3 rounded-xl px-3 py-2 text-sm font-semibold transition w-full ${
              activeKey === item.key ? 'bg-sky-500/15 text-slate-50' : 'text-slate-200 hover:bg-white/5'
            }`}
          >
            <Icon className="h-5 w-5" />
            {item.label}
          </button>
        );
      })}
    </div>
    <button
      onClick={onBack}
      className="md:mt-auto w-full rounded-xl border border-white/10 bg-white/5 px-3 py-2 text-sm font-semibold text-slate-100 hover:bg-white/10 h-10 flex items-center justify-center"
      type="button"
    >
      ← Back to app
    </button>
  </aside>
);

export default AccountNav;
